// ZonesRoutesWrapper.jsx
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { ZonesSelectionProvider } from "../../../hooks/useZoneSelection";
import ZoneScreen from ".";
import AssigmentScreen from "./assignment";
import CreateZoneScreen from "./create";
import UpdateZoneScreen from "./update";
import RepresentativesScreen from "../representative";
import DoctorZonesScreen from "../doctors";
import CreateRepresentativeScreen from '../representative/create';
import UpdateRepresentativeScreen from '../representative/update';
import ZonifyDoctorsByFileScreen from "../doctors/zonify-by-file";
export default function ZonesLayout() {
  const { path } = useRouteMatch();

  return (
<Switch>
  <Route exact path={`${path}/create`} component={CreateZoneScreen} />
  <Route exact path={`${path}/update/:visitingZoneId`} component={UpdateZoneScreen} />

  <Route exact path={`${path}/doctors`} component={DoctorZonesScreen} />
  <Route exact path={`${path}/doctors/zonify`} component={ZonifyDoctorsByFileScreen} />
  
  <Route exact path={`${path}/representative`} component={RepresentativesScreen} />
  <Route exact path={`${path}/representative/create`} component={CreateRepresentativeScreen} />
  <Route exact path={`${path}/representative/update/:labRepresentativeId`} component={UpdateRepresentativeScreen} />

  <ZonesSelectionProvider>
    <Switch>
      <Route exact path={path} component={ZoneScreen} />
      <Route exact path={`${path}/assignment`} component={AssigmentScreen} />
    </Switch>
  </ZonesSelectionProvider>

  {/* Catch-all */}
  <Redirect to={path} />
</Switch>

  );
}
